export const API_INTERACTIVE_TIME_DASHBOARD =
  'reports/reports/interactive-time-dashboard';
export const API_INTERACTIVE_TIME_DASHBOARD_COUNT =
  'reports/reports/interactive-time-dashboard-count';
export const API_INTERACTIVE_TIME_DASHBOARD_ASSIGN_UPDATE =
  'reports/reports/interactive-time-dashboard-assign';
export const API_INTERACTIVE_TIME_CSV_REPORT =
  'reports/reports/interactive-time';
export const API_INTERACTIVE_TIME_DASHBOARD_OVERVIEW_SLA =
  'reports/reports/interactive-time-dashboard-overview/sla';
